import React from 'react'


const Stock = ({ color, size }) => {
  return (
    <svg width={size || '16'} height={size || '16'} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.728 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.7273 14.7607 8 14.7607Z'
        fill={color || '#5FB20A'} />
      <path
        d='M11.6703 5.21754C11.4181 4.98826 11.0259 5.00623 10.7954 5.25967L7.01532 9.42204L5.18913 7.56551C4.94806 7.32136 4.55644 7.31764 4.31291 7.55807C4.06875 7.79789 4.06503 8.19014 4.30547 8.43429L6.59144 10.7581C6.70857 10.877 6.86719 10.9434 7.03325 10.9434C7.03697 10.9434 7.04132 10.9434 7.04504 10.944C7.21607 10.9403 7.37719 10.8671 7.49182 10.7407L11.7124 6.09317C11.9424 5.83907 11.9238 5.44745 11.6703 5.21754Z'
        fill={color || '#5FB20A'} />
    </svg>


  )
}


export default Stock
